import { apiUrl } from "./LoginSignup";

const Mailer = async (dataToSubmit) => {
  const response = await fetch(`${apiUrl}/mail/api/welcome`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(dataToSubmit),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.message || "Failed to send welcome mail.");
  }

  return data;
};

export default Mailer;